import {
    SYSTEMCONFIG_GET_SYSTEMCONFIG_LIST_BEGIN,
    SYSTEMCONFIG_GET_SYSTEMCONFIG_LIST_SUCCESS,
    SYSTEMCONFIG_GET_SYSTEMCONFIG_LIST_FAILURE,
    SYSTEMCONFIG_GET_SYSTEMCONFIG_LIST_DISMISS_ERROR,
  } from './constants';
  
  import request from '../../../utils/request'
  // Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
  // If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
  export function getSystemConfigList(params) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: SYSTEMCONFIG_GET_SYSTEMCONFIG_LIST_BEGIN,
      });
     params.size = 10;

     const promise = new Promise((resolve, reject) => {
          request({
            method:'get',
            url:'/v2/admin/system/config/list',
            data:params,
          }).then( data => {
              dispatch({
                  type: SYSTEMCONFIG_GET_SYSTEMCONFIG_LIST_SUCCESS,
                  data: Object.assign({},data,{page:params.page}),
              });
              resolve(data);
          }).catch (error => {
              dispatch({
                type: SYSTEMCONFIG_GET_SYSTEMCONFIG_LIST_FAILURE,
                data: { error: error },
              });
              reject(error);
          })
      });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissGetSystemConfigListError() {
    return {
      type: SYSTEMCONFIG_GET_SYSTEMCONFIG_LIST_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case SYSTEMCONFIG_GET_SYSTEMCONFIG_LIST_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          getSystemConfigListPending: true,
          getSystemConfigListError: null,
        };
  
      case SYSTEMCONFIG_GET_SYSTEMCONFIG_LIST_SUCCESS:
        // The request is success
  
        const byId = {};
        const items = [];
        action.data.list.forEach(item => {
          items.push(item.id);
          byId[item.id] = item;
        });
        return {
          ...state,
          systemConfigById:byId,
          systemConfigList:items,
          systemConfigPage: action.data.page,
          systemConfigSize: action.data.size,
          systemConfigTotal: action.data.count,
          getSystemConfigListPending: false,
          getSystemConfigListError: null,
        };
  
      case SYSTEMCONFIG_GET_SYSTEMCONFIG_LIST_FAILURE:
        // The request is failed
        return {
          ...state,
          getSystemConfigListPending: false,
          getSystemConfigListError: action.data.error,
        };
  
      case SYSTEMCONFIG_GET_SYSTEMCONFIG_LIST_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          getSystemConfigListError: null,
        };
  
      default:
        return state;
    }
  }


// WEBPACK FOOTER //
// ./src/features/systemconfig/redux/getSystemConfigList.js